<template>
  <div class="item profile" v-if="stock" @click="onStockClicked">
    <StockImageTag
      class="small"
      :key="stock.symbol"
      :stockData="stock"
      :imgUrl="stock.logoUrl"
      :symbol="stock.symbol"
      :market="stock.type"
      :stockId="stock.stockId"
      :disableRouting="true"
    />
    <p>
      {{ stock.symbol }}
      <span class="autoSpan">{{ stock.name }}</span>
    </p>
  </div>
</template>

<script lang="ts">
import { StockMarkets } from "../../models/stocks.model";
import utilService from "@/services/util.service";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    stock: Object,
  },
  setup(_, { emit }) {
    const getStockImage = (stockId: string, type: StockMarkets) =>
      utilService.getStockImage(stockId, type);
    const onStockClicked = () => {
      emit("clickvalue");
    };
    return { getStockImage, onStockClicked };
  },
});
</script>
<style lang="scss" scoped>
.small{
  pointer-events: none;
}
</style>